import { theme } from '../../../Assets/Styles/theme'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '12px',
    marginTop: '12px',
  },
  statusButtonsContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  buttonContainer: {
    marginRight: 5,
    cursor: 'pointer',
    padding: '10px',
  },
  acceptButton: {
    color: '#04B115',
    fontFamily: "'Proxima Nova', sans-serif",
    fontSize: 16,
    fontWeight: '700',
    borderRadius: 8,
    opacity: 0.8,
    backgroundColor: '#E0F2E1',
  },
  rejectButton: {
    color: '#D72B4F',
    fontSize: 16,
    fontFamily: "'Proxima Nova', sans-serif",
    fontWeight: '700',
    borderRadius: 8,
    opacity: 0.8,
    backgroundColor: '#FDE4E8',
  },
  cancelButton: {
    color: 'white',
    fontSize: 16,
    fontFamily: "'Proxima Nova', sans-serif",
    fontWeight: '700',
    borderRadius: 8,
    opacity: 0.8,
    backgroundColor: 'lightgray',
  },
  acceptWithHover: {
    color: '#04B115',
    fontFamily: "'Proxima Nova', sans-serif",
    fontSize: 16,
    fontWeight: '700',
    borderRadius: 8,
    transition: 'all .3s',
    '&:hover': {
      opacity: 0.8,
      backgroundColor: '#E0F2E1',
    },
  },
  rejectWithHover: {
    color: '#D72B4F',
    fontSize: 16,
    fontFamily: "'Proxima Nova', sans-serif",
    fontWeight: '700',
    borderRadius: 8,
    transition: 'all .3s',
    '&:hover': {
      opacity: 0.8,
      backgroundColor: '#FDE4E8',
    },
  },
  rejectedButtonIfDocRejected: {
    opacity: 0.8,
    borderRadius: 8,
    backgroundColor: '#FDE4E8',
  },
  acceptedButtonIfDocAccepted: {
    opacity: 0.8,
    borderRadius: 8,
    backgroundColor: '#E0F2E1',
  },
  button: {
    padding: 6,
    minWidth: 78,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  editButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 10,
    cursor: 'pointer',
  },
  saveButton: {
    fontSize: 16,
    fontFamily: "'Proxima Nova', sans-serif",
    fontWeight: '700',
    color: theme.colors.primary,
    textDecoration: 'underline',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 10,
    cursor: 'pointer',
  },
}

export default styles
